// extracted by mini-css-extract-plugin
export var style_container = "JobTags-module--style_container--5fca1";